import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Globals from "../../parameter/globals";
import { Helmet } from "react-helmet";
import AuthContext from "../../context/AuthProvider";

function CondizioniUso() {
	const [error, setError] = useState(false);
	const [message, setMessage] = useState("");
	const [condizioniUso, setCondizioniUso] = useState([]);
	const { lang } = useContext(AuthContext);

	useEffect(() => {
		getPageLegal();
	}, [lang]);

	const getPageLegal = async () => {
		try {
			const response = await axios.get(Globals.GETLEGALPAGE, {
				headers: { "Content-Type": "application/json" },
				withCredentials: true,
			});

			if (response?.data?.error === true) {
				setError(true);
				setMessage(response?.data?.error);
			} else {
				setCondizioniUso(
					lang === "it"
						? response?.data?.condizioni_utilizzo.htmlcontents_it
						: response?.data?.condizioni_utilizzo.htmlcontents_en
				);
			}
		} catch (err) {
			setError(true);
			setMessage(err);
		}
	};

	return (
		<div
			className='container'
			style={{ marginTop: "140px", marginBottom: "100px" }}>
			<Helmet>
				<meta charSet='utf-8' />
				<title>{Globals.language.title.TermsOfUse[lang]}</title>
				<link
					rel='canonical'
					href='https://www.soluzioniomniamedia.com/condizioni-uso'
				/>
								<meta name="robots" content="noindex" />

			</Helmet>
			<div dangerouslySetInnerHTML={{ __html: condizioniUso }} />
		</div>
	);
}

export default CondizioniUso;
